import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import avatar from '../../Pics/avatar.jpg'

import SpecificComponent from '../SpecificComponent'
import { Fab, FormControl, InputLabel, Select, MenuItem, Input, Grid, Checkbox } from '@material-ui/core';
import Utils from '../../providers/Utils';
import PropTypes from 'prop-types';
import Ws from '../../providers/Ws';
import OpenAddFisaPostului from './OpenAddFisaPostului';
import OpenAddCV from './OpenAddCV';


export default class DateleFirmei extends SpecificComponent {

    constructor(props) {
        super(props)
        this.state = {
            isOpenFisa: false,
            isOpenCv: false,
            disabled: false
        }
    }






    changeCui = (ev) => {
        // console.log('changecui :', );
        this.props.changeDate('cui')

        if (this.props.dateFirma.cui < 7) {
            this.setState({
                disabled: true
            })
        } else {
            this.setState({
                disabled: false
            })
        }
    }




    render() {
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    onClose={this.props.dialogClose}
                    fullWidth={true}
                    maxWidth={'md'}
                    style={{
                        zIndex: 5000
                    }}
                >

                    <DialogActions>
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>clear</i>
                        </Fab>
                    </DialogActions>

                    <h2 style={{ marginBottom: 5 }} className="pm-title">{this.props.dateFirma.nume}</h2>

                    <DialogContent style={{ width: '90%', margin: 'auto', overflow: 'hidden' }}>
                        <Grid style={{ width: '90%', margin: 'auto' }} container >
                            <Grid style={{ textAlign: 'left', marginBottom:20 }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            


                                <div style={{ position: 'relative' }}>
                                    <input
                                        id='nume'
                                        style={{ width: '90%' }}
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        name='nume'
                                        value={this.props.dateFirma.nume || ''}
                                        onChange={this.props.changeDate('nume')}
                                        placeholder={this.props.limba.organigrama.nume}
                                    />




                                    <label style={{ marginLeft: 10 }} className='inputLabelPM' htmlFor='denumireCost'>{this.props.limba.organigrama.nume}</label>

                                </div>


                                {/* <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.organigrama.nume}
                                    value={this.props.dateFirma.nume || ''}
                                    onChange={this.props.changeDate('nume')}
                                    margin="normal"
                                /> */}
                            </Grid>

                            <Grid style={{ textAlign: 'left',  marginBottom:20 }} item xs={12} sm={12} md={8} lg={8} xl={8} >
                            <div style={{ position: 'relative' }}>
                                    <input
                                        id='adresa'
                                        style={{ width: '90%' }}
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        name='nume'
                                        value={this.props.dateFirma.adresa || ''}
                                        onChange={this.props.changeDate('adresa')}
                                        placeholder={this.props.limba.organigrama.adresa}
                                    />




                                    <label style={{ marginLeft: 10 }} className='inputLabelPM' htmlFor='denumireCost'>{this.props.limba.organigrama.adresa}</label>

                                </div>
{/* 
                                <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    multiline
                                    label={this.props.limba.organigrama.adresa}
                                    value={this.props.dateFirma.adresa || ''}
                                    onChange={this.props.changeDate('adresa')}
                                    margin="normal"
                                    type='text'
                                /> */}

                            </Grid>
                            <Grid style={{ textAlign: 'left' ,  marginBottom:20}} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <div style={{ position: 'relative' }}>
                                    <input
                                        id='nrInregistrare'
                                        style={{ width: '90%' }}
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        name='nume'
                                        value={this.props.dateFirma.nr_inregistrare || ''}
                                        onChange={this.props.changeDate('nr_inregistrare')}
                                        placeholder={this.props.limba.organigrama.nrInregistrare}
                                    />




                                    <label style={{ marginLeft: 10 }} className='inputLabelPM' htmlFor='denumireCost'>{this.props.limba.organigrama.nrInregistrare}</label>

                                </div>
                                {/* <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.organigrama.nrInregistrare}
                                    value={this.props.dateFirma.nr_inregistrare || ''}
                                    onChange={this.props.changeDate('nr_inregistrare')}
                                    margin="normal"
                                    type='text'
                                /> */}

                            </Grid>

                            <Grid style={{ textAlign: 'left' ,  marginBottom:20}} item xs={12} sm={12} md={4} lg={4} xl={4} >

                            <div style={{ position: 'relative' }}>
                                    <input
                                        id='cui'
                                        style={{ width: '90%' }}
                                        className='add-project-input'
                                        type="number"
                                        margin="normal"
                                        name='nume'
                                        value={this.props.dateFirma.cui || ''}
                                        onChange={this.props.changeDate('cui')}
                                        placeholder={this.props.limba.organigrama.cui}
                                    />




                                    <label style={{ marginLeft: 10 }} className='inputLabelPM' htmlFor='denumireCost'>{this.props.limba.organigrama.cui}</label>

                                </div>

                                {/* <TextField
                                    className="inputFocus loginTextField"
                                    style={{ width: '90%' }}
                                    label={this.props.limba.organigrama.cui}
                                    value={this.props.dateFirma.cui || ''}
                                    onChange={this.props.changeDate('cui')}
                                    margin="normal"
                                    type='number'

                                /> */}
                                <span style={{
                                    display: this.props.disabled ? 'block' : 'none',
                                    color: '#d23737',
                                    textAlign: 'left',
                                    paddingLeft: 21
                                }}>* Cuiul este obligatoriu</span>
                            </Grid>

                            <Grid style={{ textAlign: 'left',  marginBottom:20 }} item xs={12} sm={12} md={4} lg={4} xl={4} >
                            <div style={{ position: 'relative' }}>
                                    <select
                                        id='cota_tva'
                                        style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        name='cota_tva'
                                        value={this.props.dateFirma.cota_tva || ""}
                                        onChange={this.props.changeDate('cota_tva')}
                                        placeholder={this.props.limba.organigrama.tva}
                                    // onBlur={this.props.insertOrUpdateCost}
                                    >


                                        {this.props.cote_tva.map((s, idx) => {
                                            return (
                                                <option key={idx} value={s.id}>{s.nume}</option>
                                            )
                                        })}

                                    </select>
                                    <label style={{ marginLeft: 10 }} className='inputLabelPM' htmlFor='tipCost'>{this.props.limba.organigrama.tva}</label>
                                </div>

                                {/* <FormControl className='inputFocus' style={{ width: '90%', marginTop: 16 }}>
                                    <InputLabel htmlFor="resursa">{this.props.limba.organigrama.tva}</InputLabel>
                                    <Select

                                        value={this.props.dateFirma.cota_tva || ""}
                                        onChange={this.props.changeDate('cota_tva')}

                                        input={<Input id="resursa" />}>


                                        {this.props.cote_tva.map((s, idx) => {

                                            // console.log('this.props.cote_tva :', s);
                                            return (<MenuItem style={{ zIndex: 7000 }} value={s.id} key={idx}  > {s.nume}</MenuItem>)

                                        })
                                        }
                                    </Select>
                                </FormControl> */}

                            </Grid>




                        </Grid>

                    </DialogContent>

                    <DialogActions>


                        <Button disabled={this.props.disabled} style={{ margin: 'auto' }} variant="outlined" onClick={() => { this.props.updateFirma(this.props.dateFirma) }} className={!this.props.disabled ? 'pm-save-button' : ''}>
                            {this.props.limba.comune.save}
                        </Button>
                    </DialogActions>

                </Dialog>







            </div>

        );
    }


}  // end class

DateleFirmei.propTypes = {
    open: PropTypes.bool,
    dialogClose: PropTypes.func,
    changeDate: PropTypes.func,
    dateFirma: PropTypes.object,
    limba: PropTypes.object,
    disabled: PropTypes.bool,
    cote_tva: PropTypes.array,
    updateFirma: PropTypes.func,



}